var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"disabled":_vm.disabled,"className":"hours"},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((24),function(n,index){return _c('option',{key:index + n,domProps:{"value":index}},[_vm._v(" "+_vm._s(index)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }